module.exports = __webpack_public_path__ + "static/media/sonic-logo.5cd6d646.png";